// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { toLayoutResult } from "./LayoutResult";
/**
 * Extract from an AnalyzeResult the fields that are produced from General Document extraction (`"prebuilt-document"`).
 *
 * @internal
 */

export function toGeneralDocumentResult(analyzeResult) {
  var keyValuePairs = analyzeResult.keyValuePairs;
  return Object.assign(Object.assign({}, toLayoutResult(analyzeResult)), {
    keyValuePairs: keyValuePairs
  });
}